/**
 * N.B. We should not add to these! Instead, sharing such thematic values via
 * CSS Custom Properties would be preferred, possibly via `StylesProvider`
 *
 * These are the various properties `fountain-ui-components` piggy-backed off
 * MUI's theme props.  We should avoid adding any more of them, though its
 * safer to bring them over from `fountain-ui-components` and pare back later
 * @see {@link https://fountain.atlassian.net/browse/AX-564}
 */
import { FDSColors } from '@fountain/fds-tokens';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

interface CustomBorders {
  gray300: CSSProperties['border'];
  gray400: CSSProperties['border'];
}

type CustomBordersOptions = Partial<CustomBorders>;

export const customBorders: CustomBordersOptions = {
  gray300: `solid 1px ${FDSColors.gray300}`,
  gray400: `solid 1px ${FDSColors.gray400}`,
};

interface CustomShadows {
  selectDropdown?: CSSProperties['boxShadow'];
}

type CustomShadowsOptions = Partial<CustomShadows>;

export const customShadows: CustomShadowsOptions = {
  selectDropdown: `0px 1px 2px ${FDSColors.gray100}`,
};

interface Misc {
  borderRadius: number;
}

export const misc: Misc = {
  borderRadius: 5,
};

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    customBorders: CustomBorders;
    customShadows: CustomShadows;
    misc: Misc;
  }

  interface ThemeOptions {
    customBorders?: CustomBordersOptions;
    customShadows?: CustomShadowsOptions;
    misc?: Partial<Misc>;
  }
}
